// Generated metadata only. Future articles are excluded.
export const newsArticles = [
  {
    "slug": "how-to-design-a-website-that-converts-insider-secrets-you-cant-afford-to-miss",
    "title": "How to Design a Website That Converts: Insider Secrets You Can’t Afford to Miss",
    "date": "2024-09-21",
    "originalPath": "/2024/09/21/how-to-design-a-website-that-converts-insider-secrets-you-cant-afford-to-miss",
    "image": "/images/news/website-conversions.jpg",
    "excerpt": "A beautiful website is only the beginning. The true test of any site lies in its ability to convert visitors into paying customers. Here are some insider secrets…"
  },
  {
    "slug": "the-power-of-content-management-systems-why-wordpress-is-a-good-choice-for-your-website",
    "title": "The Power of Content Management Systems: Why WordPress is a Good Choice for Your Website",
    "date": "2024-09-04",
    "originalPath": "/2024/09/04/the-power-of-content-management-systems-why-wordpress-is-a-good-choice-for-your-website",
    "image": "/images/news/wordpress.jpg",
    "excerpt": "With countless content management systems (CMS) available today, choosing the right one for your website is critical. Here’s why WordPress remains the industry…"
  },
  {
    "slug": "why-seo-is-the-lifeline-of-your-website-expert-tactics-for-success",
    "title": "Why SEO is the Lifeline of Your Website: Expert Tactics for Success",
    "date": "2024-08-23",
    "originalPath": "/2024/08/23/why-seo-is-the-lifeline-of-your-website-expert-tactics-for-success",
    "image": "/images/news/seo.jpg",
    "excerpt": "SEO (Search Engine Optimization) isn’t just a buzzword—it’s the key to driving organic traffic and keeping your website visible in an increasingly competitive…"
  },
  {
    "slug": "5-essential-tips-to-supercharge-your-websites-performance",
    "title": "5 Essential Tips to Supercharge Your Website’s Performance",
    "date": "2024-06-08",
    "originalPath": "/2024/06/08/5-essential-tips-to-supercharge-your-websites-performance",
    "image": "/images/news/performance.jpg",
    "excerpt": "In the fast-paced digital world, your website’s performance is directly tied to your success. A slow or poorly optimized website can drive potential customers…"
  },
  {
    "slug": "mini-hockey-scoreboard-update-submitted-to-apple",
    "title": "Mini Hockey Scoreboard update submitted to Apple",
    "date": "2022-11-27",
    "originalPath": "/2022/11/27/mini-hockey-scoreboard-update-submitted-to-apple",
    "image": "/images/news/hockey.jpg",
    "excerpt": "Mini Hockey Scoreboard, with over 250 downloads in the United States, Canada, and Czech Republic, has been updated to include a new welcome screen and goal…"
  },
  {
    "slug": "drebe-rebranded-to-fitcheck-new-update-coming-soon",
    "title": "DreBe rebranded to FitCheck, new update coming soon",
    "date": "2022-10-09",
    "originalPath": "/2022/10/09/drebe-rebranded-to-fitcheck-new-update-coming-soon",
    "image": "/images/news/fitcheck.png",
    "excerpt": "DreBe has been renamed to FitCheck, and has been updated across the Apple App Store to reflect this change. The new name does a much better job of explaining the…"
  },
  {
    "slug": "drebe-will-be-entering-beta-testing-in-the-coming-days",
    "title": "DreBe will be entering Beta testing in the coming days",
    "date": "2022-04-03",
    "originalPath": "/2022/04/03/drebe-will-be-entering-beta-testing-in-the-coming-days",
    "image": "/images/news/fitcheck.png",
    "excerpt": "DreBe has announced that it will be testing its app over the coming weeks. Groups of college students will download the app on their phone and provide feedback…"
  }
];
